/**
 * Created by kaiyan2 on 01/02/2017.
 */
import React from "react";
import BlogItem from "./BlogItem";
import {getLatestContent, getLatestContentByID} from "Common/utility/jive"

import {generateInfoCard, generate} from "Common/utility/infoCard";


var monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];


export default class Blog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: null
    };
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    if (this.props.config) {
      this.getBlogData(this.props.config);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.config && this.props.config != prevProps.config) {
      this.getBlogData(this.props.config);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }


  getBlogData(config) {
    const jiveblogid = config.queryChild("jiveid");
    const jivename = config.queryChild("jivename");
    const count = config.queryChild("count") ? config.queryChild("count").innerText.trim() : 4;


    if (jiveblogid && jiveblogid.innerText.trim()) {
      getLatestContentByID(jiveblogid.innerText.trim(), "blog", count)
        .then(this.generateItems.bind(this))
        .catch(this.handleError.bind(this));
    } else if (jivename && jivename.innerText.trim()) {
      getLatestContent(jivename.innerText.trim(), "blog", count)
        .then(this.generateItems.bind(this))
        .catch(this.handleError.bind(this));
    }
  }


  generateItems(data) {

    if (!this.mounted) {
      return;
    }

    if (!data.results) {
      this.setState({
        items: []
      });
      return;
    }


    let itemSize = 0;
    const length = data.results.list.length;
    //item < 2 show nothing, item size is 2 or 3 show 2, item size >= 4, show 4
    if (length >= 2 && length < 4)
      itemSize = 2;
    else if (length >= 4)
      itemSize = 4;
    let items = [];
    for (let i = 0; i < itemSize; i++) {
      const _data = data.results.list[i];
      const date = new Date(_data.publishDate);
      const dateString = monthNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
      let item = {
        id: _data.id,
        title: _data.subject,
        subtitle: `by ${_data.author.displayName} | ${dateString}`,
        description: _data.content.text,
        link: {
          text: "Read more",
          url: _data.permalink,
          target: "_blank"
        },
        image: {
          src: _data.author.resources.avatar.ref,
          url: _data.permalink,
          target: "_blank"
        }
      };
      items.push(item);
    }
    this.setState({
      items
    });
  }

  handleError() {
    this.setState({
      items: []
    });
  }


  render() {
    const {config, location} = this.props;
    this.location = location;

    if (!config) {
      return <span className="pubhub-loading"></span>
    }

    const elements = generate(config, location, this.props.type);

    var content = <span className="pubhub-loading"></span>

    if (this.state.items) {

      if (this.state.items.length) {
        content = this.state.items.map((item, index) => {
          return <div className="col-md-6 col-sm-12 pubhub-community-blog-content-item" key={index}><BlogItem
            data={item} key={item.id}/></div>
        });
      } else {
        content = <p>No Blog</p>
      }

    }


    return (
      <div className="pubhub-community-blog pubhub-widget">
        <div className="container">
          <h1>
            {elements.title}
          </h1>
          <div className="pubhub-community-blog-subtitle row">
            <div className="col">
              {elements.subtitle}
            </div>
          </div>

          <div className="pubhub-community-blog-content row">
            {content}
          </div>

          <div className="pubhub-community-blog-button row">
            <div className="col">
               <span data-track-name="blog:viewmore"
                     data-track-value="view more">
                 {elements.link}
          </span>

            </div>

          </div>
        </div>
      </div>
    )
  }

}

